const en_master_customer = {
    add: "add customer",
    address: "customer address",
    edit: "edit customer",
    email: "customer email",
    name: "customer name",
    phone: "customer phone",
    upload: "upload customer",

    form: {
        ppn_label: "Enable to use PPN",
        upload_title: "input customer data"
    },

    error: {
        create: "Failed to create customer.",
        delete: "Failed to delete customer.",
        edit: "Failed to update customer.",
    },

    success: {
        create: "Customer created successfully.",
        delete: "Customer deleted successfully.",
        edit: "Customer updated successfully.",
    }
}

export default en_master_customer;